import React, { Component } from "react";
import { Table, Card, Row, Col, Form, Image } from "react-bootstrap";
import PatientsOrderView from "./PatientsOrderView";
import ReactPaginate from "react-paginate";

import "../../Common/Common.css";
var dateFormat = require("dateformat");
var moment = require("moment");
class PatientsOrder extends Component {
  constructor(props) {
    super(props);
    this.paginationreset = React.createRef();
    this.state = {
      PatientsOrderShow: false,

      page: 0,
      perPage: 10,

      searchpatientsorder: "",
      filterValue: ""
    };
  }

  componentDidMount() {
    this.props.PatientOrder({
      page: undefined,
      searchquery: this.state.searchpatientsorder,
      filter: this.state.filterValue
    });
  }

  //For detail view
  handlePatientsOrderView = item => {
    this.setState(
      {
        PatientsOrderShow: true,
        PatientsOrdersDtls: item
      });
  };

  handleClosePatientsOrder = () => {
    this.setState({ PatientsOrderShow: false });
  };

  //For pagination
  handlePageClick = e => {
    const selectedPage = e.selected;
    this.props.PatientsOrderSlectedPage({
      page: selectedPage + 1,
      searchquery: this.state.searchpatientsorder,
      filter: this.state.filterValue
    });
    this.setState({ page: selectedPage });
  };
  resetPage = () => {
    this.setState({ page: 0 });
  };

  //For filter
  handleChange = event => {
    this.setState(
      {
        filterValue: event.target.value,
        page: 0
      },
      () => {
        this.props.PatientOrder({
          page: undefined,
          searchquery: this.state.searchpatientsorder,
          filter: this.state.filterValue
        });
      }
    ); //Synchronised call
  };

  //For search
  SearchOnChange = event => {
    this.setState(
      {
        searchpatientsorder: event.target.value,
        page: 0
      },
      () => {
        this.props.PatientOrder({
          page: undefined,
          searchquery: this.state.searchpatientsorder,
          filter: this.state.filterValue
        });
      }
    );
  };

  render() {
    //Destructuring
    const {
      patientorederDtlsCount,
      patientorederDtlsList,
      itemCount,
      itemList,
      itempageSelected
    } = this.props;
    const {
      page,
      perPage,
      searchpatientsorder,
      filterValue,
      PatientsOrderShow,
      PatientsOrdersDtls
    } = this.state;
    const {
      SearchOnChange,
      handleChange,
      handlePatientsOrderView,
      handlePageClick,
      paginationreset,
      handleClosePatientsOrder
    } = this;

    //For pagination
    let p = page + 1;
    const count = patientorederDtlsCount && patientorederDtlsCount;
    let PatientsOrderPageCount = Math.ceil(count / perPage);

    return (
      <div>
        <Card>
          <Card.Header>
               <Row className="align-items-center w-100 justify-content-between tableHeaderRow">
              <Col xs={12} sm={12} md={3} lg={3}>
                <h3>Patient Orders</h3>
              </Col>
              
              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonFilterDiv">
                  <select
                    value={filterValue}
                    onChange={handleChange}
                    className="commonFilterSelect"
                  >
                    <option value="">All</option>
                    <option value="created">Created</option>
                    <option value="accepted">Accepted</option>
                    {/* <option value="paid">Paid</option> */}
                    <option value="shipmentReady">Dispatched</option>
                    <option value="delivered">Delivered</option>
                    <option value="cancelled">Cancelled</option>
                    <option value="rejected">Rejected</option>
                    <option value="expired">Expired</option>
                  </select>
                </div>
              </Col>

              <Col xs={12} sm={12} md={3} lg={3}>
                <div>
                  <div className="commonInput">
                    <i className="fa fa-search fa-lg cmnSearchIcon"></i>
                    <input
                      type="text"
                      placeholder="Order Id/User/Chemist"
                      value={searchpatientsorder}
                      onChange={SearchOnChange}
                    />
                  </div>
                </div>
              </Col>
              
              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonRecrd">
                  <i className="cui-note icons cmnRecordIcon"></i>
                  <span className="cmnPageCount">
                    {count !== undefined ? count : 0}
                  </span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <div>
              <Table responsive bordered striped className="cmnMainTable">
                <thead>
                  <tr className="cmnMainTableHd">
                    <th>SL NO</th>
                    <th>ORDER ID</th>
                    <th>USER NAME</th>
                    <th>PATIENT NAME</th>
                    <th>CHEMIST</th>
                    <th>CREATED DATE & TIME</th>
                    <th>STATUS</th>
                    <th>ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {patientorederDtlsList &&
                    patientorederDtlsList.map((item, i) => (
                      <tr key={i}>
                        <td className="cmn_Cap">{10 * (p - 1) + i + 1}</td>
                        <td className="">
                          {item !== null &&
                            item.orderFrom !== null &&
                            item.orderNo}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null &&item.orderFromName}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null &&
                            item.prcpId !== null &&
                            item.prcpId.patientName}
                        </td>

                        <td className="cmn_Cap">
                          {item !== null && item.orderToName}
                        </td>
                        <td className="cmn_Cap ">
                          {item !== null && item.createdAt
                            ? dateFormat(item.createdAt, "dd-mmm-yyyy, h:MM TT")
                            : null}
                        </td>
                        {/* <td className="cmn_Cap">
                        {item.createdAt !== null &&
                          dateFormat(item.createdAt, "h:MM TT")}
                      </td> */}
                        <td className="cmn_Cap ">
                          {item !== null && item.status&&item.status==="shipmentReady"?"Dispatched":item.status}
                        </td>
                        <td className="cmnViewIcon">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center"
                            }}
                          >
                            <i
                              className="fa fa-eye fa-lg "
                              onClick={() =>
                                handlePatientsOrderView({ item: item })
                              }
                            ></i>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
              <PatientsOrderView
                show={PatientsOrderShow}
                close={handleClosePatientsOrder}
                PatientsOrdersDtls={PatientsOrdersDtls}
              />
              {(patientorederDtlsList === undefined ||
                (patientorederDtlsList && patientorederDtlsCount === 0)) && (
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require("../../../../src/assets/img/nodata4.png")}
                    />
                  </div>
                  <div className="noDataTextDiv">No Orders Found</div>
                </div>
              )}
            </div>
          </Card.Body>
          {PatientsOrderPageCount > 1 ? (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={page}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={PatientsOrderPageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName={"pagination flex-wrap"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          ) : null}
        </Card>
      </div>
    );
  }
}
export default PatientsOrder;
